import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Confirmation from "@/pages/Confirmation";
import Awards2027 from "@/pages/Awards2027";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/essex-wedding-awards-2027" element={<Awards2027 />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#F6F1E8",
            border: "1px solid #1A1A1A",
            borderRadius: "2px",
            fontFamily: "Manrope, sans-serif",
            letterSpacing: "0.04em",
            fontSize: "0.85rem",
          },
        }}
      />
    </div>
  );
}

export default App;
